export const CHRISTMAS_PARTY_ARTICLE = {
  path: "/blog/christmas-party-venue-west-melbourne",
  title: "Christmas Party Venue in West Melbourne: Cambodian Feasts at ANGKOR",
  headline: "Christmas Party Venue in West Melbourne: Cambodian Feasts at ANGKOR",
  description:
    "Planning an end-of-year or Christmas party near Southern Cross? ANGKOR at 389 Spencer St offers Cambodian feasts for groups of 12+ and exclusive hire for up to 38 guests.",
  image:
    "/manus-storage/angkor-restaurant-interior-west-melbourne_b573dae6.webp",
  imageAlt: "Dining room at ANGKOR Cambodian Flavours, West Melbourne",
  datePublished: "2026-11-02",
  dateLabel: "2 November 2026",
  byline: "By the ANGKOR team",
  excerpt:
    "ANGKOR in West Melbourne offers shared Cambodian feasts and exclusive hire for easy end-of-year celebrations.",
} as const;
